import ApiService from '@/helpers/api.service';
import moment from "moment";
import { Storage } from 'aws-amplify';
const API = new ApiService();

const ROULETTE_ITEM_ENDPOINT = '/roulette';

export const state = {
    rouletteItem: [],
    rouletteItemPage: {
      totalRows: 0,
      totalPage: 0
    },
    rouletteMainDropdown: [],
    rouletteMain: [],
    rouletteMainPage: {
      totalRows: 0,
      totalPage: 0
    },
    rouletteRewards: [],
    rouletteRewardsPage: {
      totalRows: 0,
      totalPage: 0
    },
    rouletteWinnersConfigData: [],
    errors: null
}

export const mutations = {
    //ITEM
    UPDATE_ROULETTE_ITEM_LIST(state, item){
      state.rouletteItem = item;
    },
    UPDATE_BUSS_CATEGORY_PAGE(state, pageInfo){
        state.rouletteItemPage = pageInfo;
    },
    //MAIN
    UPDATE_ROULETTE_MAIN_DROPDOWN_LIST(state, item){
      state.rouletteMainDropdown = item;
    },
    UPDATE_ROULETTE_MAIN_LIST(state, item){
      state.rouletteMain = item;
    },
    UPDATE_ROULETTE_MAIN_PAGE(state, pageInfo){
        state.rouletteMainPage = pageInfo;
    },
    // Reward
    UPDATE_ROULETTE_REWARD_LIST(state, item){
      state.rouletteRewards = item;
    },
    UPDATE_ROULETTE_REWARD_PAGE(state, pageInfo){
      state.rouletteRewardsPage = pageInfo;
    },
    // Winners Config
    UPDATE_ROULETTE_WINNERS_CONFIG(state, item){
      state.rouletteWinnersConfigData = item;
    },
    SET_PROD_ERRORS(state, errors){
      state.errors = errors;
    }
}

export const actions = {
   
    // Product Roulette Item actions
    listRouletteItem(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/items`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_ROULETTE_ITEM_LIST', data.message.rows);
              context.commit('UPDATE_BUSS_CATEGORY_PAGE', {
                  totalRows: data.message.pageInfo.total,
                  totalPage: data.message.pageInfo.noOfPage
              });
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    createRouletteItem(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/create`, params)
          .then(({data}) => {
            if(data.status == "err" ||  data.status == "warning"){
              reject(data.message);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    updateRouletteItem(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/update`, params)
          .then(({data}) => {
            if(data.status == "err" ||  data.status == "warning"){
              reject(data.message);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    
    getRouletteItem(context, id){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/item-info`, {itemId: id})
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data.message.rows[0]);
            }
          })
          .catch(({response}) => {
            context.commit('SET_ESELLER_ERROR', response.data.errors);
          })
      });
    },
    getRouletteItemPercentages(context, id){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/item-chances`, {rouletteId: id})
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data.message.rows[0].itemChanceTotalPercentages);
            }
          })
          .catch(({response}) => {
            context.commit('SET_ESELLER_ERROR', response.data.errors);
          })
      });
    },
    
    deleteRouletteItem(context, id){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/delete`, {itemId: id})
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data.message);
            }
          })
          .catch(({response}) => {
            context.commit('SET_ESELLER_ERROR', response.data.errors);
          })
      });
    },
    //MAIN
    listRouletteMain(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/main`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_ROULETTE_MAIN_LIST', data.message.rows);
              context.commit('UPDATE_ROULETTE_MAIN_PAGE', {
                  totalRows: data.message.pageInfo.total,
                  totalPage: data.message.pageInfo.noOfPage
              });
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    listRouletteMainDropdown(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/main-dropdown`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_ROULETTE_MAIN_DROPDOWN_LIST', data.message.rows);
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    getRouletteMain(context, id){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/main-info`, {mainId: id})
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data.message.rows);
            }
          })
          .catch(({response}) => {
            context.commit('SET_ESELLER_ERROR', response.data.errors);
          })
      });
    },
    createRouletteMain(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/main-create`, params)
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    updateRouletteMain(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/main-update`, params)
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },

    // REWARDS
    listRouletteReward(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/reward`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject();
            } else {
              context.commit('UPDATE_ROULETTE_REWARD_LIST', data.message.rows);
              context.commit('UPDATE_ROULETTE_REWARD_PAGE', {
                  totalRows: data.message.pageInfo.total,
                  totalPage: data.message.pageInfo.noOfPage
              });
              resolve();
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    getRouletteReward(context, peddlrTrackingId){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/reward-info`, {peddlrTrackingId: peddlrTrackingId})
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data.message.rows);
            }
          })
          .catch(({response}) => {
            context.commit('SET_ESELLER_ERROR', response.data.errors);
          })
      });
    },
    createRecordRoulette(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/create-record-roulette`, params)
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },

    // Winners Configuration
    listRouletteWinnersConfig(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/get-winners-config`, params)
          .then(({ data }) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data.message.rows);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    createRouletteWinnersConfig(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/create-winners-config`, params)
          .then(({data}) => {
            if(data.status == "err"){
              reject(data);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
    updateRouletteWinnersConfig(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${ROULETTE_ITEM_ENDPOINT}/update-winners-config`, params)
          .then(({data}) => {
            if(data.status == "err"){
              reject(data.message);
            } else {
              resolve(data);
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },

    // Logo upload
    uploadLogo(context, params){
      return new Promise((resolve, reject) => {
        var allowedType = ["jpg","jpeg","png","svg"];
        if(params.type && !allowedType.includes(params.type.toLowerCase())){
          reject("Filetype not allowed");
          return;
        }
  
        var metadata =  {
          customPrefix: {
            public: ''
          },
          expires: moment().add(365, 'days').toDate(),
        }
  
        if(params.type == 'svg'){
          metadata['contentType'] = 'image/svg+xml';
        }
        Storage.put(`${params.folder}/${params.filename}`, params.base64, metadata)
          .then(stored => {
              console.log(stored);

              resolve(stored.key.replace(params.folder + "/", ""));
          })
          .catch(err => {
              console.log(err);
              reject(err);
          });
      });
    }
  }
  